import { PaymentPageInfo } from '../types/paymentPageInfo'
import api from './api'

const getPaymentPageInfo = async (paymentPageId: string): Promise<PaymentPageInfo> => {
    return await api('/api/payment-page/info', { paymentPageId }) as PaymentPageInfo
}

export default getPaymentPageInfo
